// extracted by mini-css-extract-plugin
export default {"errorWrap":"_PdwEnnmK1AB_ydTyeSq","icon":"yu9QckS8iGmAKtrr5qPb","title":"l4pLLY7Ju3vDPtQuT_DX","description":"EmmfgdF5H0Jf2bAkz4xg"};